<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: {
      handler(nv, ov) {
        if (document.getElementById("message")) {
          document.getElementById("message").style.display = "none";
        }
      }
    },
    deep: true
  }
};
</script>
<style lang="less" type="text/less" scoped>
#app {
  background-color: #f6f6f6;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue